import MessageHub from './signalr/SignalrMessageHub';

class RealtimeSubscriptionManager {
  subscriptions = {};
  mergedStatus = {};

  constructor() {
    MessageHub.subscribe('socketClosed', () => this.recall(this.subscriptions));
  }

  subscribe(channel, merged = true) {
    // chua co => merge = true || false

    if (!this.subscriptions[channel]) {
      this.subscriptions[channel] = 1;
      MessageHub.subscribe(channel, null, merged);
    } else {
      if (!merged && this.mergedStatus[channel]) {
        MessageHub.subscribe(channel, null, merged);
      }
    }
    this.mergedStatus[channel] = merged;
  }

  unsubscribe(channel) {
    if (this.subscriptions[channel]) {
      this.subscriptions[channel]--;
      this.mergedStatus[channel] = undefined;
      // if (this.subscriptions[channel] === 0) {
      //   // xóa trang thái merge với channel
      //   this.mergedStatus[channel] = undefined;
      //   //MessageHub.unsubscribe(channel);
      // }
    }
  }

  recall(subscriptions) {
    for (var key in subscriptions) {
      MessageHub.subscribe(key, this.mergedStatus[key]);
    }
  }
}

var realtimeSubscriptionManager = new RealtimeSubscriptionManager();

export default realtimeSubscriptionManager;
